import request from '@/utils/request'

/**
 * 获取报表自定义组件列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listReportCustomComponent(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomComponent.listReportCustomComponent',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}